const state = {
    overlays: {},
    pageWrapStyle: {
        position: "",
        top: "",
        left: "",
    },
    lastScrollY: window.pageYOffset,
    courseInfo: "",
};

export default state;



// WEBPACK FOOTER //
// ./scripts/sky-overlay/store/state.js